import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Bus/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Bus from "../CommanBarTable_Bus";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
import { BallTriangle } from "react-loader-spinner";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function SocAtChargeStartCycles_Bus({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("SOC at which charging starts");
  let barcolor
  let toPush = [];
  let toPushfast = [];
  const appyDataCycles = (data) => {
    res_result = data;
    toPush = [];
    let responce = {
      "<=10": 0,
      "20": 0,
      "30": 0,
      "40": 0,
      "50": 0,
      "60": 0,
      "70": 0,
      "80": 0,
      "90": 0,
      ">90": 0,
    }

    if (res_result.length !== 0) {
      let d = res_result[0];

      if (d.B1.value)
        responce["<=10"] = d.B1.value
      if (d.B2.value)
        responce["20"] = d.B2.value
      if (d.B3.value)
        responce["30"] = d.B3.value
      if (d.B4.value)
        responce["40"] = d.B4.value
      if (d.B5.value)
        responce["50"] = d.B5.value
      if (d.B6.value)
        responce["60"] = d.B6.value
      if (d.B7.value)
        responce["70"] = d.B7.value
      if (d.B8.value)
        responce["80"] = d.B8.value
      if (d.B9.value)
        responce["90"] = d.B9.value
      if (d.B10.value)
        responce[">90"] = d.B10.value

      toPush.push(d.B1.value)
      toPush.push(d.B2.value)
      toPush.push(d.B3.value)
      toPush.push(d.B4.value)
      toPush.push(d.B5.value)
      toPush.push(d.B6.value)
      toPush.push(d.B7.value)
      toPush.push(d.B8.value)
      toPush.push(d.B9.value)
      toPush.push(d.B10.value)

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<=10", "20", "30", "40", "50", "60", "70", "80", "90", ">90"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          // barcolor
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<=10", "20", "30", "40", "50", "60", "70", "80", "90", ">90"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "SoC(%)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'SoC(%)'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'SoC(%)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',

    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#3578b0" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "charging_api_bus/" + apiend, body: { filterdata: gloablfilter } }, appyDataCycles)
    barcolor = "#3578b0"
    SetChartName("SOC at which charging starts");
  }, [gloablfilter, type])

  const [toPushPopUp, settoPushPopUp] = useState([]);
  const appyDataClick = (data) => {
    let toPushPopUpArr = []
    let hits = data;

    hits.map((i, key) => {
      toPushPopUpArr.push({
        "key": {
          "vehicleId": i.key.vehicleId,
          "Depot_Name": i.key.Depot_Name,
          "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
          "vehicle_registration_number": i.key.vehicle_registration_number
        },
        "doc_count": 9,
        "median_soc_start": {
          "values": {
            "50.0": i.doc_count
          }
        }
      })
    })
    toPushPopUpArr.sort((a, b) => b.median_soc_start.values["50.0"] - a.median_soc_start.values["50.0"]);
    settoPushPopUp(toPushPopUpArr)
  }

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;
            if (count !== 0) {
              if (barvalue === "<=10") {
                from_bucket = 0
                to_bucket = 10
              } else if (barvalue === ">90") {
                from_bucket = 90
                to_bucket = null
              } else {
                from_bucket = barvalue - 10
                to_bucket = barvalue
              }

              fetchData({ url: API_URL_MAIN + "charging_api_bus/soc_at_charge_start_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              window.$('#exampleModal__' + apiend).modal('show');
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Cycles Count</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Bus data={toPushPopUp} tabDataKey={"median_soc_start"} />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SocAtChargeStartCycles_Bus;